import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import SongSelector from '../song-selector';

const filterAlbumSongs = (albumSongs = [], tracksList) => {
	return tracksList.filter((song) => {
		return albumSongs.map(({ id }) => id).indexOf(song.id) === -1;
	});
};

@inject('songsStore')
@observer
class SongList extends Component {
	constructor (props) {
		super(props);

		const { songsStore, album } = this.props;
		const albumSongs = album.songs;
		const songs = filterAlbumSongs(albumSongs, songsStore.songs);

		this.state = { songs, albumSongs };
	}

	render() {
		const { songsStore } = this.props;
		const { songs = [], albumSongs = [] } = this.state;

		return (
			<SongSelector
				addSong={ this.addSong }
				removeSong={ this.removeSong }
				onDragEnd={ this. onDragEnd }
				songList={ songs }
				selectedSongs={ albumSongs } />
		);
	}

	@autobind
	onDragEnd ({
		source: { index: startIndex },
		destination: { index: endIndex }
	}) {
		const albumSongs = this.state.albumSongs.slice();
		const [ removed ] = albumSongs.splice(startIndex, 1);

		albumSongs.splice(endIndex, 0, removed);

		this.setState({ albumSongs });
		this.props.album.songs = albumSongs;
	}

	@autobind
	addSong (songID) {
		const albumSongs = this.state.albumSongs.concat(
			this.state.songs.filter(({ id }) => id === songID)
		);

		const songs = filterAlbumSongs(albumSongs,
			this.props.songsStore.songs);

		this.setState({ songs, albumSongs });
		this.props.album.songs = albumSongs;
	}

	@autobind
	removeSong (songID) {
		const albumSongs = this.state.albumSongs
			.filter(({ id }) => id !== songID);
		const songs = filterAlbumSongs(albumSongs,
			this.props.songsStore.songs);

		this.setState({ songs, albumSongs });
		this.props.album.songs = albumSongs;
	}
}

export default SongList;
